var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Switch_Icon_03"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Switch_Icon_03",
    "data-name": "Switch Icon 03",
    clipPath: "url(#clip-Switch_Icon_03)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3707",
    "data-name": "Group 3707",
    transform: "translate(0.416 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_333",
    "data-name": "Group 333",
    transform: "translate(-0.002 6.44)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    y1: 8.525,
    transform: "translate(1.039 0.149)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M86.55,67.947h-4.1v1.885H94.841",
    transform: "translate(-82.45 -59.273)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M82.588,3.39H94.942",
    transform: "translate(-82.569 -3.39)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5964",
    "data-name": "Path 5964",
    d: "M111.168-44.544h2.049v1.629h1.629V-40.7h-1.629v1.629H111V-40.7h-1.629v-2.215h1.8Z",
    transform: "translate(-105.757 44.543)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3712",
    "data-name": "Group 3712",
    transform: "translate(6.194 6.835)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5989",
    "data-name": "Path 5989",
    d: "M874,378.813a.442.442,0,0,0-.067-.234h0l0,0a.449.449,0,0,0-.069-.085l-2-2.46a.444.444,0,1,0-.7.547h0l1.484,1.791-9.5,0a.445.445,0,1,0,0,.889l10.36,0,.048,0,.049,0h0A.444.444,0,0,0,874,378.813Z",
    transform: "translate(-862.701 -375.84)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5990",
    "data-name": "Path 5990",
    d: "M869.251,603.205a.444.444,0,0,0,.067.234h0l0,0a.444.444,0,0,0,.069.085l2,2.46a.444.444,0,1,0,.7-.547h0l-1.484-1.791,9.5,0a.445.445,0,1,0,0-.889l-10.36,0-.048,0-.049,0h0A.445.445,0,0,0,869.251,603.205Z",
    transform: "translate(-869.059 -597.109)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3694",
    "data-name": "Group 3694",
    transform: "translate(3 11.617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M99.829,56.7h1.785",
    transform: "translate(-99.829 -54.188)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3693",
    "data-name": "Group 3693"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M101.614,41.758V39.25H99.829v2.508",
    transform: "translate(-99.829 -39.25)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3697",
    "data-name": "Group 3697",
    transform: "translate(3.001 7.861)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_307-2",
    "data-name": "Path 307",
    d: "M98.847,30.571h1.785",
    transform: "translate(-98.847 -28.063)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3696",
    "data-name": "Group 3696"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_308-2",
    "data-name": "Path 308",
    d: "M100.632,15.633V13.125H98.847v2.508",
    transform: "translate(-98.847 -13.125)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchIcon);
export default __webpack_public_path__ + "static/media/SwitchIcon.e72dfb9a50cc67486529d37eb02add82.svg";
export { ForwardRef as ReactComponent };